/**
 * Created by Ella Ma on 2020/09/11.
 * ------ maintenance history ------
 */

import { Component, OnInit, Input } from '@angular/core';
import { GatewayTypes, TaskTypes } from '../../../tamalelibs/models/workflow.model';
import { DiagramNode } from '../diagram-service';
import { DiagramService } from '../diagram.service';

@Component({
    selector: 'tam-diagram-node',
    templateUrl: './diagram-node.component.html',
    styleUrls: ['./diagram-node.component.scss']
})
export class DiagramNodeComponent implements OnInit {

    /**
     * gets or sets the id of the gateway branch current node belongs to.
     */
    @Input() branchId: string;

    @Input() set nodeId(guid) {
        this.node = this._nodesService.getNode(guid);
    }

    node: DiagramNode;
    TaskTypes = TaskTypes;
    GatewayTypes = GatewayTypes;

    constructor(
        private _nodesService: DiagramService,
    ) { }

    isGatewayNode() {
        return this._nodesService.isGatewayNode(this.node);
    }

    ngOnInit() {
    }
}
